/*
 * cc-auto-select-size.js
 * When a user clicks a colour radio and the currently-selected size is
 * unavailable for that colour, switch the size radio to the first
 * available variant for that colour BEFORE Dawn's VariantSelects bubble
 * handler fires (capture phase).
 */
(function () {
  function getPosition(name) {
    if (!name) return null;
    const m = name.trim().match(/-(\d+)$/);
    return m ? parseInt(m[1], 10) : null;
  }

  function readVariants(scope) {
    const node = scope.querySelector('[data-cc-product-variants]');
    if (!node) return null;
    try {
      const v = JSON.parse(node.textContent);
      return Array.isArray(v) ? v : null;
    } catch {
      return null;
    }
  }

  document.addEventListener(
    'change',
    function (event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (target.type !== 'radio') return;

      const variantSelects = target.closest('variant-selects');
      if (!variantSelects) return;

      // Only react when the changed input is the Colour option.
      const fieldset = target.closest('fieldset.product-form__input');
      if (!fieldset || !fieldset.querySelector('label.cc-colour-btn')) return;

      const variants = readVariants(variantSelects);
      if (!variants || variants.length === 0) return;

      const colourPos = getPosition(target.name);
      if (!colourPos) return;
      const newColour = target.value;

      // Build current selection by option position from all checked radios.
      const selection = {};
      variantSelects
        .querySelectorAll('fieldset.product-form__input')
        .forEach(function (fs) {
          const checked = fs.querySelector('input[type="radio"]:checked');
          if (!checked) return;
          const pos = getPosition(checked.name);
          if (pos) selection[pos] = checked.value;
        });

      const matches = function (variant) {
        for (const pos in selection) {
          if (variant['option' + pos] !== selection[pos]) return false;
        }
        return true;
      };

      // Current selection already maps to an available variant — nothing to do.
      if (variants.some(function (v) { return matches(v) && v.available; })) {
        return;
      }

      // Find the first available variant for the newly-clicked colour.
      const fallback = variants.find(function (v) {
        return v['option' + colourPos] === newColour && v.available;
      });
      if (!fallback) return; // colour fully sold out; let Dawn show "unavailable"

      // Update the OTHER option radios so the selection matches `fallback`.
      variantSelects
        .querySelectorAll('fieldset.product-form__input')
        .forEach(function (fs) {
          const checked = fs.querySelector('input[type="radio"]:checked');
          if (!checked || checked === target) return;
          const pos = getPosition(checked.name);
          if (!pos) return;
          const desired = fallback['option' + pos];
          if (checked.value === desired) return;
          const newRadio = fs.querySelector(
            'input[type="radio"][value="' + CSS.escape(desired) + '"]'
          );
          if (!newRadio) return;
          checked.checked = false;
          checked.removeAttribute('checked');
          newRadio.checked = true;
          newRadio.setAttribute('checked', 'checked');
        });
    },
    true // capture phase — runs before VariantSelects.connectedCallback's bubble handler
  );
})();
